import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';

export const getAiPath = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post(`/AiPath/loadAiPathData`, {
			userId,
		});
		logger.log('Response from LoadAiPathData: ', response?.data?.data);
		return {
			READING_WRITING: response?.data?.READING_WRITING || [],
			MATHS: response?.data.MATHS || [],
		};
	} catch (error) {
		return {
			error: error?.response?.data?.message,
			data: { READING_WRITING: [], MATHS: [] }, // fallback empty structure
		};
	}
};
